import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function PageHero({ eyebrow, title, description, breadcrumb = [] }) {
  return (
    <section
      data-testid="page-hero"
      className="relative overflow-hidden border-b border-white/5"
    >
      <div className="absolute inset-0 aurora-bg opacity-90" />
      <div className="absolute inset-0 subtle-grid pointer-events-none" />
      <div className="shell relative section-pad !py-16 sm:!py-20">
        <nav
          aria-label="Breadcrumb"
          className="flex items-center text-xs text-slate-400 gap-1.5 flex-wrap"
        >
          <Link to="/" className="hover:text-white inline-flex items-center gap-1">
            <Home className="w-3.5 h-3.5" /> Beranda
          </Link>
          {breadcrumb.map((b, i) => (
            <span key={i} className="inline-flex items-center gap-1.5">
              <ChevronRight className="w-3.5 h-3.5 opacity-60" />
              {b.to ? (
                <Link to={b.to} className="hover:text-white">
                  {b.label}
                </Link>
              ) : (
                <span className="text-slate-300">{b.label}</span>
              )}
            </span>
          ))}
        </nav>

        {eyebrow && (
          <span className="gold-pill mt-6" data-testid="page-hero-eyebrow">
            {eyebrow}
          </span>
        )}
        <h1
          data-testid="page-hero-title"
          className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight max-w-4xl"
        >
          {title}
        </h1>
        {description && (
          <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-3xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}
